export const aboutHeroSubtitle = 'About SALTED';
export const aboutHeroTitle = 'Understanding Human Movement.\nExpanding Life.';
export const aboutHeroDescription = 'Translating human movement into digital language,\nexpanding the possibilities of life';

// Tab Navigation
export const tabStory = 'Our Story';
export const tabCompetency = 'Core Competency';
export const tabHistory = 'History';
export const tabPeople = 'People';
export const tabPartner = 'Partner';
export const tabCI = 'CI';

// Origin Story Section
export const originSectionTitle = 'It started with a simple question';
export const originText1 = 'SALTED began with a small idea\nduring our time as a Samsung Electronics in-house venture.';
export const originText2 = 'What is the most universal yet\nmost important action for humanity?';
export const originText3 = 'The answer was "walking".';
export const originText4 = 'Walking is the most routine action\npeople repeat every day,\nand the movement that most naturally reveals\nhealth, balance, and physical condition.';
export const originText5 = 'People walk every day.\nMedical technology has advanced rapidly,\nbut there still wasn\'t enough ways to objectively\nexplain "how well you are walking".';

// Ground Truth Section
export const groundTruthTitle = 'The answer was always beneath our feet';
export const groundTruthText1 = 'Through analyzing countless gait data, we discovered that the most important information about human movement lies at the point where the foot meets the ground.';
export const groundTruthText2 = 'Plantar pressure, ground reaction force, and center of pressure movement are signals that most honestly reveal a person\'s physical condition, balance, and functional changes.';
export const groundTruthText3 = 'SALTED has designed sensors, accumulated data, and repeatedly refined analysis models to properly understand these signals.';
export const groundTruthText4 = 'Through this process, smart insole technology was born, and the platform "NeuroGait" for interpreting human movement was created.';
export const groundTruthText5 = 'This is how SALTED began to understand and interpret human movement.';

// Technology Section
export const technologyTitle = 'We are not just a measurement company';
export const technologyText1 = 'SALTED collects physical signals from human gait, balance, and posture.';
export const technologyText2 = 'We don\'t stop at collection.';
export const technologyText3 = 'In the sports industry, we have challenged the golf, running, and training markets with the goal of improving user performance, utilizing movement data for training and performance improvement.';
export const technologyText4 = 'In the medical industry, we have built a physical function assessment solution based on gait, balance, and posture to evaluate movements associated with specific diseases.';
export const technologyText5 = 'Through this, we have created standards that medical professionals can use to understand patient conditions more objectively and apply to diagnosis and treatment.';

// Vision Section
export const visionTitle = 'Our Vision';
export const visionText1 = 'SALTED\'s vision is to translate human movement into digital language and expand the possibilities of life.';
export const visionText2 = 'Movement is a matter of survival, health, and freedom.';
export const visionText3 = 'By translating gait and balance into digital language, we aim to help more people walk through their lives longer, safer, and more independently.';

// Mission Section
export const missionTitle = 'Our Mission';
export const missionText1 = 'By 2030, we aim to complete\na Physical OS\nthat understands human movement.';
export const missionText2 = 'This Physical OS will become a common foundation that helps AI understand the human body.';
export const missionText3 = 'Medical diagnosis, robot control, personalized insurance, sports industry—\nan infrastructure that enables different industries to operate on the same standard.';
export const missionText4 = 'We are not making products,\nwe are creating standards for understanding the human body in the AI era.';

// CEO Message Section
export const ceoMessageTitle = 'CEO Message';
export const ceoText1 = 'SALTED started with humanity\'s most fundamental movement: "the power to walk".';
export const ceoText2 = 'We have believed that within the most routine action of walking lies the most essential information for gauging human health, balance, and life sustainability.';
export const ceoText3 = 'Technology has advanced rapidly, but standards for properly understanding the human body have not yet been sufficiently established.';
export const ceoText4 = 'SALTED believes that solving this gap is the necessary next step in the AI era.';
export const ceoText5 = 'By 2030, we aim to complete a Physical OS that understands human movement.';
export const ceoText6 = 'We believe this will be a starting point that changes how people and technology meet, beyond a single product or technology.';
export const ceoText7 = 'SALTED\'s goal is to create a world where everyone can walk through their lives longer, safer, and more independently.';
export const ceoText8 = 'We believe that establishing standards for understanding human movement is expanding the possibilities of life, so we will continue to challenge this path without stopping.';
export const ceoName = 'Hyungjin Cho';
export const ceoTitle = 'CEO, SALTED Inc.';

// CTA Section
export const ctaTitle = 'Start with SALTED';
export const ctaDescription = 'We will lead your business to the next level with innovative solutions';
export const ctaButton = 'Contact Us';

export default {
  aboutHeroSubtitle,
  aboutHeroTitle,
  aboutHeroDescription,
  tabStory,
  tabCompetency,
  tabHistory,
  tabPeople,
  tabPartner,
  tabCI,
  originSectionTitle,
  originText1,
  originText2,
  originText3,
  originText4,
  originText5,
  groundTruthTitle,
  groundTruthText1,
  groundTruthText2,
  groundTruthText3,
  groundTruthText4,
  groundTruthText5,
  technologyTitle,
  technologyText1,
  technologyText2,
  technologyText3,
  technologyText4,
  technologyText5,
  visionTitle,
  visionText1,
  visionText2,
  visionText3,
  missionTitle,
  missionText1,
  missionText2,
  missionText3,
  missionText4,
  ceoMessageTitle,
  ceoText1,
  ceoText2,
  ceoText3,
  ceoText4,
  ceoText5,
  ceoText6,
  ceoText7,
  ceoText8,
  ceoName,
  ceoTitle,
  ctaTitle,
  ctaDescription,
  ctaButton
};